import { GeneralHttpResponse } from "../types/genericTypes";
import axios from "axios";
import env from "react-dotenv";

//Catálogo categorías
export const createRequisicionHttp = async (data: FormData) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}/createRequisicion`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const updateRequisicionHttp = async (data: FormData) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}/reabrirRequisicion`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
//Catálogo categorías
export const cancelarRequisicionHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}/cancelarRequisicion`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};

export const getRequisicionesHttp = async (search?: string, idUsuario?: number) => {
  try {
    const url = new URL(`${env.API_URL}/getRequisiciones`);
    if (search) url.searchParams.append("search", search);
    if (idUsuario) url.searchParams.append("id_usuario", String(idUsuario));

    const response = await axios.get(url.toString());
    return response?.data?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getEventosBitacoraHttp = async () => {
  try {
    const response = await axios.get(`${env.API_URL}/getEventosBitacora`);
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getEstatusRequisicionHttp = async () => {
  try {
    const response = await axios.get(`${env.API_URL}/getEstatusRequisicion`);
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const editarCategoriaHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.put(`${env.API_URL}/editarCategoria`, data);
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const desactivarCategoriaHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.put(
      `${env.API_URL}/desactivarCategoria`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const activarCategoriaHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.put(`${env.API_URL}/activarCategoria`, data);
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const mandarAutorizarHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}${"/mandarAutorizar"}`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const marcarAtendidaHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}${"/marcarAtendida"}`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getRequisicionPorIdHttp = async (datos?: {
  id_requisicion: number | string;
  id_usuario_creador?: number | string;
}) => {
  try {
    const response = await axios.get(`${env.API_URL}/getRequisicionPorId`, {
      params: datos,
    });
    return response?.data?.data || response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const procesoAutorizacionHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}${"/procesoAutorizacion"}`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getJefeInmediatoHttp = async (datos?: number) => {
  try {
    const response = await axios.get(`${env.API_URL}/getJefeInmediato`, {
      params: datos,
    });
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getRequisicionPorIdSinCifrarHttp = async (datos?: number) => {
  try {
    const response = await axios.get(`${env.API_URL}/getRequisicionPorIdSinCifrar`, {
      params: datos,
    });
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getBitacoraRequisicionHttp = async (datos?: number) => {
  try {
    const response = await axios.get(`${env.API_URL}/getBitacoraRequisicion`, {
      params: datos,
    });
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getVerDetalleEstadisticaHttp = async (datos?: any) => {
  try {
    const response = await axios.get(`${env.API_URL}/getVerDetalleEstadistica`, {
      params: datos,
    });
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const surtirDisponibleHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}${"/surtirDisponibleRequisicion"}`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const marcarProductoAtendidoHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}${"/marcarProductoAtendido"}`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const cambiarProyectoRequisicionHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}${"/cambiarProyectoRequisicion"}`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const cambiarEmpresaRequisicionHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}${"/cambiarEmpresaRequisicion"}`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const reportarProblemaHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}${"/reportarProblema"}`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};